import { useEffect } from "react";

const useTitle = title =>{
    useEffect(()=> {
        document.title = `${title} - Shakil Ahamed`;
    }, [title])
}

export default useTitle;